import React from 'react';
// import { useProjectStore } from '../../stores/projectStore';

const Forum: React.FC = () => {
//   const { projects, fetchProjects } = useProjectStore();

//   useEffect(()=> {
    
//     fetchProjects()
//   })

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold">Forum</h1>
      {/* <ul>
        {projects.map((project) => (
          <li key={project.id} className="p-2 border-b">
            {project.title}
          </li>
        ))}
      </ul> */}
    </div>
  );
};

export default Forum;
